module.exports = __webpack_public_path__ + "cee9d2c07fdaa098fa90f59c4c079e1f.png";